var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 250",
    width: 150,
    height: "100%",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 250,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-93.99899291992188,-209.99996948242188)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,149.91000366210938,362.7829895019531)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M-20.584999084472656,5.896999835968018 C-20.584999084472656,5.896999835968018 2.953000068664551,5.896999835968018 2.953000068664551,5.896999835968018 C13.027999877929688,5.896999835968018 20.71500015258789,-1.722000002861023 20.71500015258789,-11.706999778747559 C20.71500015258789,-21.691999435424805 13.027999877929688,-29.31100082397461 2.953000068664551,-29.31100082397461 C2.953000068664551,-29.31100082397461 -20.71500015258789,-29.31100082397461 -20.71500015258789,-29.31100082397461 C-20.71500015258789,-29.31100082397461 -20.71500015258789,5.854000091552734 -20.71500015258789,5.854000091552734 C-20.71500015258789,5.854000091552734 -20.71500015258789,29.31100082397461 -20.71500015258789,29.31100082397461"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,178.06500244140625,397.22698974609375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M-25.20199966430664,-28.547000885009766 C-25.20199966430664,-28.547000885009766 1.277999997138977,1.6269999742507935 1.277999997138977,1.6269999742507935 M9.38700008392334,10.868000030517578 C9.38700008392334,10.868000030517578 25.20199966430664,28.547000885009766 25.20199966430664,28.547000885009766"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,178.5449981689453,400.0050048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M24.72100067138672,-25.434999465942383 C24.72100067138672,-25.434999465942383 -24.72100067138672,25.434999465942383 -24.72100067138672,25.434999465942383"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-94,-230.50001525878906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,278.7170104980469,399.0830078125)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M19.812999725341797,36.722999572753906 C17.218000411987305,50.99800109863281 3.9809999465942383,60.10100173950195 -10.446000099182129,57.53300094604492 C-24.87299919128418,54.96500015258789 -34.073001861572266,41.869998931884766 -31.47800064086914,27.594999313354492 C-31.47800064086914,27.594999313354492 -19.812999725341797,-36.722999572753906 -19.812999725341797,-36.722999572753906 C-17.218000411987305,-50.99800109863281 -3.9809999465942383,-60.10100173950195 10.446000099182129,-57.53300094604492 C24.87299919128418,-54.96500015258789 34.073001861572266,-41.869998931884766 31.47800064086914,-27.594999313354492 C31.47800064086914,-27.594999313354492 31.47800064086914,-27.594999313354492 31.47800064086914,-27.594999313354492 C31.47800064086914,-27.594999313354492 19.812999725341797,36.722999572753906 19.812999725341797,36.722999572753906z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,278.95098876953125,398.9219970703125)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M25.426000595092773,4.715000152587891 C25.426000595092773,4.715000152587891 -25.426000595092773,-4.715000152587891 -25.426000595092773,-4.715000152587891"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,192.87100219726562,134.39498901367188)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M-9.470999717712402,-8.95199966430664 C-6.809000015258789,-9.432000160217285 -4.025000095367432,-9.22599983215332 -1.4620000123977661,-8.359999656677246 C1.1009999513626099,-7.49399995803833 3.437999963760376,-5.968999862670898 5.263000011444092,-3.9719998836517334 C8.467000007629395,-0.46700000762939453 9.994000434875488,4.50600004196167 9.3100004196167,9.204999923706055"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,87.19097900390625,125.21600341796875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M49.11800003051758,118.92900085449219 C49.11800003051758,118.92900085449219 -80.01100158691406,118.92900085449219 -80.01100158691406,118.92900085449219 C-80.01100158691406,118.92900085449219 -80.01100158691406,-118.92900085449219 -80.01100158691406,-118.92900085449219 C-80.01100158691406,-118.92900085449219 27.714000701904297,-118.92900085449219 27.714000701904297,-118.92900085449219 C27.714000701904297,-118.92900085449219 80.01100158691406,-66.63099670410156 80.01100158691406,-66.63099670410156 C80.01100158691406,-66.63099670410156 80.01100158691406,-10.32699966430664 80.01100158691406,-10.32699966430664"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,141.05499267578125,32.435001373291016)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M26.14900016784668,26.14900016784668 C26.14900016784668,26.14900016784668 -26.14900016784668,-26.14900016784668 -26.14900016784668,-26.14900016784668 C-26.14900016784668,-26.14900016784668 -26.14900016784668,26.14900016784668 -26.14900016784668,26.14900016784668 C-26.14900016784668,26.14900016784668 26.14900016784668,26.14900016784668 26.14900016784668,26.14900016784668z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(1,0,0,1,50.069976806640625,32.57500076293945)",
    opacity: 1
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M-18.179000854492188,0 C-18.179000854492188,0 18.179000854492188,0 18.179000854492188,0"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(1,0,0,1,50.069976806640625,49.736000061035156)",
    opacity: 1
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M-18.179000854492188,0 C-18.179000854492188,0 18.179000854492188,0 18.179000854492188,0"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(1,0,0,1,58.358978271484375,66.89600372314453)",
    opacity: 1
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 8.639,
    d: " M-26.468000411987305,0 C-26.468000411987305,0 26.468000411987305,0 26.468000411987305,0"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "D",
    transform: "matrix(1,0,0,1,822.7490234375,116.33300018310547)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M5.88,0 C5.88,0 25.63,0 25.63,0 C33.73,0 40.44,-2.5 45.75,-7.51 C51.07,-12.52 53.73,-18.86 53.73,-26.55 C53.73,-34.14 51.07,-40.36 45.75,-45.21 C40.44,-50.17 33.73,-52.64 25.63,-52.64 C25.63,-52.64 5.88,-52.64 5.88,-52.64 C5.88,-52.64 5.88,0 5.88,0z M15.17,-44.05 C15.17,-44.05 25.63,-44.05 25.63,-44.05 C30.84,-44.05 35.25,-42.37 38.86,-39.02 C42.43,-35.66 44.21,-31.51 44.21,-26.55 C44.21,-21.55 42.43,-17.29 38.86,-13.78 C35.35,-10.32 30.94,-8.59 25.63,-8.59 C25.63,-8.59 15.17,-8.59 15.17,-8.59 C15.17,-8.59 15.17,-44.05 15.17,-44.05z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "E",
    transform: "matrix(1,0,0,1,774.8099975585938,116.33300018310547)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M44.13,-44.05 C44.13,-44.05 44.13,-52.64 44.13,-52.64 C44.13,-52.64 5.88,-52.64 5.88,-52.64 C5.88,-52.64 5.88,0 5.88,0 C5.88,0 44.13,0 44.13,0 C44.13,0 44.13,-8.59 44.13,-8.59 C44.13,-8.59 15.17,-8.59 15.17,-8.59 C15.17,-8.59 15.17,-21.68 15.17,-21.68 C15.17,-21.68 41.03,-21.68 41.03,-21.68 C41.03,-21.68 41.03,-30.27 41.03,-30.27 C41.03,-30.27 15.17,-30.27 15.17,-30.27 C15.17,-30.27 15.17,-44.05 15.17,-44.05 C15.17,-44.05 44.13,-44.05 44.13,-44.05z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "S",
    transform: "matrix(1,0,0,1,721.761962890625,116.33399963378906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M11.54,-49.24 C7.97,-46.24 6.19,-42.3 6.19,-37.39 C6.19,-29.39 11.15,-24.41 21.06,-22.45 C21.06,-22.45 29.73,-20.75 29.73,-20.75 C34.89,-19.77 37.47,-17.6 37.47,-14.24 C37.47,-12.03 36.55,-10.28 34.72,-9.02 C32.89,-7.75 30.37,-7.12 27.17,-7.12 C23.3,-7.12 20.13,-8.03 17.65,-9.83 C15.17,-11.64 13.7,-14.09 13.24,-17.19 C13.24,-17.19 4.03,-17.19 4.03,-17.19 C4.49,-11.51 6.74,-7.05 10.76,-3.79 C14.79,-0.54 20.08,1.08 26.63,1.08 C32.77,1.08 37.68,-0.41 41.34,-3.41 C45.11,-6.4 46.99,-10.37 46.99,-15.33 C46.99,-19.3 45.7,-22.44 43.12,-24.74 C40.54,-27.03 36.57,-28.72 31.2,-29.81 C31.2,-29.81 24.54,-31.12 24.54,-31.12 C21.6,-31.74 19.44,-32.59 18.08,-33.68 C16.71,-34.76 16.03,-36.26 16.03,-38.17 C16.03,-40.54 16.97,-42.41 18.85,-43.78 C20.73,-45.15 23.28,-45.83 26.48,-45.83 C33.24,-45.83 37.08,-42.92 38.01,-37.08 C38.01,-37.08 47.23,-37.08 47.23,-37.08 C46.92,-40.13 46.08,-42.77 44.71,-45.02 C43.34,-47.26 41.61,-49.01 39.52,-50.24 C37.43,-51.48 35.25,-52.39 32.98,-52.95 C30.71,-53.52 28.34,-53.81 25.86,-53.81 C19.97,-53.81 15.2,-52.28 11.54,-49.24z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "N",
    transform: "matrix(1,0,0,1,663.3709716796875,116.33300018310547)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M43.2,-52.64 C43.2,-52.64 43.2,-16.34 43.2,-16.34 C43.2,-16.34 12.93,-52.64 12.93,-52.64 C12.93,-52.64 5.88,-52.64 5.88,-52.64 C5.88,-52.64 5.88,0 5.88,0 C5.88,0 15.17,0 15.17,0 C15.17,0 15.17,-35.46 15.17,-35.46 C15.17,-35.46 45.13,0 45.13,0 C45.13,0 52.41,0 52.41,0 C52.41,0 52.41,-52.64 52.41,-52.64 C52.41,-52.64 43.2,-52.64 43.2,-52.64z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "E",
    transform: "matrix(1,0,0,1,615.4320068359375,116.33300018310547)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M44.13,-44.05 C44.13,-44.05 44.13,-52.64 44.13,-52.64 C44.13,-52.64 5.88,-52.64 5.88,-52.64 C5.88,-52.64 5.88,0 5.88,0 C5.88,0 44.13,0 44.13,0 C44.13,0 44.13,-8.59 44.13,-8.59 C44.13,-8.59 15.17,-8.59 15.17,-8.59 C15.17,-8.59 15.17,-21.68 15.17,-21.68 C15.17,-21.68 41.03,-21.68 41.03,-21.68 C41.03,-21.68 41.03,-30.27 41.03,-30.27 C41.03,-30.27 15.17,-30.27 15.17,-30.27 C15.17,-30.27 15.17,-44.05 15.17,-44.05 C15.17,-44.05 44.13,-44.05 44.13,-44.05z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "C",
    transform: "matrix(1,0,0,1,553.635009765625,116.33300018310547)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M18.89,-13.01 C15.48,-16.52 13.78,-20.95 13.78,-26.32 C13.78,-31.69 15.48,-36.13 18.89,-39.64 C22.3,-43.1 26.58,-44.83 31.74,-44.83 C35.87,-44.83 39.32,-43.73 42.08,-41.53 C44.84,-39.34 46.73,-36.23 47.77,-32.21 C47.77,-32.21 57.37,-32.21 57.37,-32.21 C56.13,-38.66 53.19,-43.87 48.54,-47.84 C43.9,-51.77 38.3,-53.73 31.74,-53.73 C24.1,-53.73 17.6,-51.12 12.23,-45.91 C6.97,-40.75 4.34,-34.22 4.34,-26.32 C4.34,-18.48 6.97,-11.95 12.23,-6.74 C17.6,-1.52 24.1,1.08 31.74,1.08 C38.35,1.08 43.95,-0.85 48.54,-4.72 C53.19,-8.7 56.13,-13.94 57.37,-20.44 C57.37,-20.44 47.77,-20.44 47.77,-20.44 C46.73,-16.41 44.84,-13.3 42.08,-11.11 C39.32,-8.92 35.87,-7.82 31.74,-7.82 C26.58,-7.82 22.3,-9.55 18.89,-13.01z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "I",
    transform: "matrix(1,0,0,1,530.5479736328125,116.33300018310547)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M5.88,-52.64 C5.88,-52.64 5.88,0 5.88,0 C5.88,0 15.17,0 15.17,0 C15.17,0 15.17,-52.64 15.17,-52.64 C15.17,-52.64 5.88,-52.64 5.88,-52.64z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "L",
    transform: "matrix(1,0,0,1,484.5439758300781,116.33300018310547)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M15.17,-8.36 C15.17,-8.36 15.17,-52.64 15.17,-52.64 C15.17,-52.64 5.88,-52.64 5.88,-52.64 C5.88,-52.64 5.88,0 5.88,0 C5.88,0 42.89,0 42.89,0 C42.89,0 42.89,-8.36 42.89,-8.36 C42.89,-8.36 15.17,-8.36 15.17,-8.36z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton-Bold",
    fontStyle: "normal",
    fontWeight: 700,
    "aria-label": " ",
    transform: "matrix(1,0,0,1,450.8450012207031,116.33399963378906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: "",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton-Bold",
    fontStyle: "normal",
    fontWeight: 700,
    "aria-label": ".",
    transform: "matrix(1,0,0,1,431.9389953613281,116.33399963378906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M14.09,-0.58 C15.48,-1.9 16.18,-3.51 16.18,-5.42 C16.18,-7.28 15.48,-8.86 14.09,-10.18 C12.7,-11.5 11.02,-12.15 9.06,-12.15 C7.15,-12.15 5.51,-11.5 4.14,-10.18 C2.77,-8.86 2.09,-7.28 2.09,-5.42 C2.09,-3.51 2.77,-1.9 4.14,-0.58 C5.51,0.74 7.15,1.39 9.06,1.39 C11.02,1.39 12.7,0.74 14.09,-0.58z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "S",
    transform: "matrix(1,0,0,1,378.8899841308594,116.33399963378906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M11.54,-49.24 C7.97,-46.24 6.19,-42.3 6.19,-37.39 C6.19,-29.39 11.15,-24.41 21.06,-22.45 C21.06,-22.45 29.73,-20.75 29.73,-20.75 C34.89,-19.77 37.47,-17.6 37.47,-14.24 C37.47,-12.03 36.55,-10.28 34.72,-9.02 C32.89,-7.75 30.37,-7.12 27.17,-7.12 C23.3,-7.12 20.13,-8.03 17.65,-9.83 C15.17,-11.64 13.7,-14.09 13.24,-17.19 C13.24,-17.19 4.03,-17.19 4.03,-17.19 C4.49,-11.51 6.74,-7.05 10.76,-3.79 C14.79,-0.54 20.08,1.08 26.63,1.08 C32.77,1.08 37.68,-0.41 41.34,-3.41 C45.11,-6.4 46.99,-10.37 46.99,-15.33 C46.99,-19.3 45.7,-22.44 43.12,-24.74 C40.54,-27.03 36.57,-28.72 31.2,-29.81 C31.2,-29.81 24.54,-31.12 24.54,-31.12 C21.6,-31.74 19.44,-32.59 18.08,-33.68 C16.71,-34.76 16.03,-36.26 16.03,-38.17 C16.03,-40.54 16.97,-42.41 18.85,-43.78 C20.73,-45.15 23.28,-45.83 26.48,-45.83 C33.24,-45.83 37.08,-42.92 38.01,-37.08 C38.01,-37.08 47.23,-37.08 47.23,-37.08 C46.92,-40.13 46.08,-42.77 44.71,-45.02 C43.34,-47.26 41.61,-49.01 39.52,-50.24 C37.43,-51.48 35.25,-52.39 32.98,-52.95 C30.71,-53.52 28.34,-53.81 25.86,-53.81 C19.97,-53.81 15.2,-52.28 11.54,-49.24z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton-Bold",
    fontStyle: "normal",
    fontWeight: 700,
    "aria-label": " ",
    transform: "matrix(1,0,0,1,376.34698486328125,116.33399963378906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: "",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton-Bold",
    fontStyle: "normal",
    fontWeight: 700,
    "aria-label": ".",
    transform: "matrix(1,0,0,1,357.44097900390625,116.33399963378906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M14.09,-0.58 C15.48,-1.9 16.18,-3.51 16.18,-5.42 C16.18,-7.28 15.48,-8.86 14.09,-10.18 C12.7,-11.5 11.02,-12.15 9.06,-12.15 C7.15,-12.15 5.51,-11.5 4.14,-10.18 C2.77,-8.86 2.09,-7.28 2.09,-5.42 C2.09,-3.51 2.77,-1.9 4.14,-0.58 C5.51,0.74 7.15,1.39 9.06,1.39 C11.02,1.39 12.7,0.74 14.09,-0.58z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "U",
    transform: "matrix(1,0,0,1,300.0719909667969,116.33399963378906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M42.43,-52.64 C42.43,-52.64 42.43,-23.38 42.43,-23.38 C42.43,-18.74 41.13,-14.92 38.55,-11.92 C35.97,-8.98 32.59,-7.51 28.41,-7.51 C24.23,-7.51 20.85,-8.98 18.27,-11.92 C15.69,-14.92 14.4,-18.74 14.4,-23.38 C14.4,-23.38 14.4,-52.64 14.4,-52.64 C14.4,-52.64 5.11,-52.64 5.11,-52.64 C5.11,-52.64 5.11,-23.38 5.11,-23.38 C5.11,-15.84 7.23,-9.88 11.46,-5.5 C15.74,-1.06 21.39,1.16 28.41,1.16 C35.38,1.16 41.01,-1.06 45.29,-5.5 C49.57,-9.94 51.72,-15.9 51.72,-23.38 C51.72,-23.38 51.72,-52.64 51.72,-52.64 C51.72,-52.64 42.43,-52.64 42.43,-52.64z",
    style: {
      display: "inherit"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255,255,255)",
    fontSize: 77.4184417724609,
    fontFamily: "Campton",
    fontStyle: "normal",
    fontWeight: 500,
    "aria-label": "PHARMACY",
    transform: "matrix(1,0,0,1,301.9289855957031,214.05899047851562)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M5.88,0 C5.88,0 15.17,0 15.17,0 C15.17,0 15.17,-15.41 15.17,-15.41 C15.17,-15.41 24.39,-15.41 24.39,-15.41 C31.1,-15.41 36.44,-17.14 40.41,-20.59 C44.49,-24.05 46.53,-28.67 46.53,-34.45 C46.53,-39.87 44.62,-44.26 40.8,-47.61 C36.98,-50.97 31.95,-52.64 25.7,-52.64 C25.7,-52.64 5.88,-52.64 5.88,-52.64 C5.88,-52.64 5.88,0 5.88,0z M15.17,-44.05 C15.17,-44.05 25.39,-44.05 25.39,-44.05 C28.95,-44.05 31.83,-43.17 34.03,-41.42 C36.22,-39.66 37.32,-37.34 37.32,-34.45 C37.32,-31.3 36.22,-28.76 34.03,-26.83 C31.83,-24.89 28.95,-23.92 25.39,-23.92 C25.39,-23.92 15.17,-23.92 15.17,-23.92 C15.17,-23.92 15.17,-44.05 15.17,-44.05z M90.97,-52.64 C90.97,-52.64 90.97,-30.12 90.97,-30.12 C90.97,-30.12 64.72,-30.12 64.72,-30.12 C64.72,-30.12 64.72,-52.64 64.72,-52.64 C64.72,-52.64 55.43,-52.64 55.43,-52.64 C55.43,-52.64 55.43,0 55.43,0 C55.43,0 64.72,0 64.72,0 C64.72,0 64.72,-21.52 64.72,-21.52 C64.72,-21.52 90.97,-21.52 90.97,-21.52 C90.97,-21.52 90.97,0 90.97,0 C90.97,0 100.18,0 100.18,0 C100.18,0 100.18,-52.64 100.18,-52.64 C100.18,-52.64 90.97,-52.64 90.97,-52.64z M154.45,0 C154.45,0 164.28,0 164.28,0 C164.28,0 141.29,-52.95 141.29,-52.95 C141.29,-52.95 132.62,-52.95 132.62,-52.95 C132.62,-52.95 109.47,0 109.47,0 C109.47,0 119.46,0 119.46,0 C119.46,0 124.33,-11.69 124.33,-11.69 C124.33,-11.69 149.5,-11.69 149.5,-11.69 C149.5,-11.69 154.45,0 154.45,0z M127.97,-20.28 C127.97,-20.28 136.88,-41.65 136.88,-41.65 C136.88,-41.65 145.93,-20.28 145.93,-20.28 C145.93,-20.28 127.97,-20.28 127.97,-20.28z M207.4,0 C207.4,0 218.71,0 218.71,0 C218.71,0 203.46,-18.66 203.46,-18.66 C207.22,-19.9 210.18,-21.96 212.32,-24.85 C214.46,-27.74 215.53,-31.12 215.53,-34.99 C215.53,-40.26 213.62,-44.52 209.8,-47.77 C206.04,-51.02 201.13,-52.64 195.09,-52.64 C195.09,-52.64 173.49,-52.64 173.49,-52.64 C173.49,-52.64 173.49,0 173.49,0 C173.49,0 182.78,0 182.78,0 C182.78,0 182.78,-17.34 182.78,-17.34 C182.78,-17.34 193.16,-17.34 193.16,-17.34 C193.16,-17.34 207.4,0 207.4,0z M182.78,-44.05 C182.78,-44.05 194.78,-44.05 194.78,-44.05 C198.19,-44.05 200.98,-43.23 203.15,-41.57 C205.31,-39.92 206.4,-37.73 206.4,-34.99 C206.4,-32.26 205.31,-30.06 203.15,-28.41 C200.98,-26.76 198.19,-25.94 194.78,-25.94 C194.78,-25.94 182.78,-25.94 182.78,-25.94 C182.78,-25.94 182.78,-44.05 182.78,-44.05z M274.6,-52.64 C274.6,-52.64 254.32,-19.9 254.32,-19.9 C254.32,-19.9 234.04,-52.64 234.04,-52.64 C234.04,-52.64 227.38,-52.64 227.38,-52.64 C227.38,-52.64 227.38,0 227.38,0 C227.38,0 236.75,0 236.75,0 C236.75,0 236.59,-32.36 236.59,-32.36 C236.59,-32.36 251.53,-8.44 251.53,-8.44 C251.53,-8.44 257.18,-8.44 257.18,-8.44 C257.18,-8.44 271.89,-32.05 271.89,-32.05 C271.89,-32.05 271.89,0 271.89,0 C271.89,0 281.26,0 281.26,0 C281.26,0 281.26,-52.64 281.26,-52.64 C281.26,-52.64 274.6,-52.64 274.6,-52.64z M335.45,0 C335.45,0 345.29,0 345.29,0 C345.29,0 322.29,-52.95 322.29,-52.95 C322.29,-52.95 313.62,-52.95 313.62,-52.95 C313.62,-52.95 290.47,0 290.47,0 C290.47,0 300.46,0 300.46,0 C300.46,0 305.34,-11.69 305.34,-11.69 C305.34,-11.69 330.5,-11.69 330.5,-11.69 C330.5,-11.69 335.45,0 335.45,0z M308.98,-20.28 C308.98,-20.28 317.88,-41.65 317.88,-41.65 C317.88,-41.65 326.94,-20.28 326.94,-20.28 C326.94,-20.28 308.98,-20.28 308.98,-20.28z M367.51,-13.01 C364.1,-16.52 362.4,-20.95 362.4,-26.32 C362.4,-31.69 364.1,-36.13 367.51,-39.64 C370.91,-43.1 375.2,-44.83 380.36,-44.83 C384.49,-44.83 387.93,-43.73 390.69,-41.53 C393.45,-39.34 395.35,-36.23 396.38,-32.21 C396.38,-32.21 405.98,-32.21 405.98,-32.21 C404.74,-38.66 401.8,-43.87 397.16,-47.84 C392.51,-51.77 386.91,-53.73 380.36,-53.73 C372.72,-53.73 366.21,-51.12 360.85,-45.91 C355.58,-40.75 352.95,-34.22 352.95,-26.32 C352.95,-18.48 355.58,-11.95 360.85,-6.74 C366.21,-1.52 372.72,1.08 380.36,1.08 C386.96,1.08 392.56,-0.85 397.16,-4.72 C401.8,-8.7 404.74,-13.94 405.98,-20.44 C405.98,-20.44 396.38,-20.44 396.38,-20.44 C395.35,-16.41 393.45,-13.3 390.69,-11.11 C387.93,-8.92 384.49,-7.82 380.36,-7.82 C375.2,-7.82 370.91,-9.55 367.51,-13.01z M454.21,-52.64 C454.21,-52.64 438.65,-26.86 438.65,-26.86 C438.65,-26.86 423.17,-52.64 423.17,-52.64 C423.17,-52.64 412.87,-52.64 412.87,-52.64 C412.87,-52.64 434.01,-17.73 434.01,-17.73 C434.01,-17.73 434.01,0 434.01,0 C434.01,0 443.45,0 443.45,0 C443.45,0 443.45,-17.73 443.45,-17.73 C443.45,-17.73 464.51,-52.64 464.51,-52.64 C464.51,-52.64 454.21,-52.64 454.21,-52.64z",
    style: {
      display: "inherit"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.91e9b011ebac70e58f27598ac2d0ac19.svg";
export { ForwardRef as ReactComponent };